import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Switch } from '../../../common/html/switch'
import { PopupAction } from '../../../common/popup/PopupAction'
import { TooltipEmail } from '../TooltipEmail'
import { selectLoading, selectProfileById } from '../store/slice'
import { updateProfileSendEmail } from '../store/thunk'
import classes from './index.module.scss'

export const EnableEmailCell = ({ rowId, checked }) => {
  const dispatch = useDispatch()

  const isLoadingUpdate = useSelector(selectLoading('updateSettings'))
  const dataRow = useSelector(selectProfileById(rowId))

  const [isShow, setIsShow] = useState(false)

  const handleOpen = () => {
    setIsShow(true)
  }

  const handleClose = () => {
    setIsShow(false)
  }

  const dispatchUpdateEmail = async () => {
    const payload = { alertProfileId: rowId, enableEmail: !checked }
    dispatch(updateProfileSendEmail(payload))
  }

  const disabled = dataRow?.disabled && !dataRow?.isDefaultProfile

  const handleChange = (isCheck) => {
    if (isLoadingUpdate) return

    if (isCheck) {
      dispatchUpdateEmail()
    } else {
      handleOpen()
    }
  }

  const handleSubmit = () => {
    dispatchUpdateEmail()
    handleClose()
  }

  return (
    <>
      <TooltipEmail
        contentClass={classes.tooltipEmail}
        children={(isEmailActive) => (
          <>
            <Switch
              checked={checked}
              onChange={handleChange}
              allowChange={isEmailActive && !disabled}
              appendStyle={{ justifyContent: 'center' }}
            />
          </>
        )}
      />

      <PopupAction
        isShow={isShow}
        title="alertSetting.DISABLE_EMAILS"
        btnCancel={{
          label: 'common.NO',
          isI18n: true,
          event: handleClose,
        }}
        btnSubmit={{
          label: 'common.YES',
          isI18n: true,
          event: handleSubmit,
        }}
        handleClose={handleClose}
      >
        <Element className="pb1">
          <Element style={{ color: '#3A414B' }}>
            <Translate value="alertSetting.DISABLE_EMAILS_CONFIRM" />
          </Element>
        </Element>
      </PopupAction>
    </>
  )
}
